import React from 'react';
import { Form, Switch, Spin, Input, Tooltip, Select, Row, Col, Button, Upload, Icon, notification, InputNumber } from 'antd';
import { END_POINT } from '../../constants/config';

const FormItem = Form.Item;

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class BreadCrumbsForm extends React.Component {
    constructor() {
        super();
        this.state = {
            link: "",
            alt: "",
            desktop_image: null,
            mobile_image: null,
            status: 0,
        }
    }

    componentDidMount() {
        this.setState({
            link: "",
            title: "",
            order: null,
        })
    }
    componentWillReceiveProps(nextProps) {

        if (nextProps.initialData.link && this.state.link === "") {
            this.setState({ link: nextProps.initialData.link });
        }
        if (nextProps.initialData.title && this.state.title === "") {
            this.setState({ title: nextProps.initialData.title });
        }
        if (nextProps.initialData.order && this.state.order === null) {
            this.setState({ order: nextProps.initialData.order });
        }
    }
    handleSubmit = e => {

        e.preventDefault();
        if (this.submittedAt > Date.now() - 500) {
            return;
        }
        this.submittedAt = Date.now();

        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            this.props.submit(Object.assign({}, fieldsValue, {}));
        })
    }



    render() {

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        };
        const { getFieldDecorator, getFieldsError } = this.props.form;
        return (
            <div style={{ direction: 'rtl' }}>
                <Form onSubmit={this.handleSubmit}>
                    <Row>
                        <Col span={9} offset={1}>

                        </Col>
                        <Col span={11} offset={1}>


                            <FormItem
                                {...formItemLayout}
                                label={"لینک"}
                                colon={true} >
                                {getFieldDecorator('link', {
                                    initialValue: this.props.initialData.link ? this.props.initialData.link : null,
                                    rules: [
                                        {
                                            required: true,
                                            message: 'لینک اجباری است ',
                                        },
                                        {
                                            ///only link with http or https
                                            pattern: new RegExp(/^(http|https):\/\//),
                                            message: 'لینک باید با http یا https شروع شود',
                                        }
                                    ],
                                })(
                                    <Input />
                                )}
                            </FormItem>
                        </Col>


                    </Row>
                    <Row>
                        <Col span={9} offset={1}>

                        </Col>

                        <Col span={11} offset={1}>


                            <FormItem
                                {...formItemLayout}
                                label={"عنوان"}
                                colon={true} >
                                {getFieldDecorator('title', {
                                    initialValue: this.props.initialData.title ? this.props.initialData.title : null,
                                    rules: [
                                        {
                                            required: true,
                                            message: 'عنوان: ',

                                        },
                                        {
                                            validator: async (_, title) => {
                                                if (title.length >= 250) {
                                                    return Promise.reject(new Error("حداکثر ۲۵۰ کاراکتر مجاز است"));
                                                }
                                            },
                                        }
                                    ],
                                })(
                                    <Input />
                                )}
                            </FormItem>
                        </Col>


                    </Row>
                    <Row>
                        <Col span={6} offset={16}>
                            <FormItem
                                {...formItemLayout}
                                label={"اولویت"}
                                colon={true} >
                                {getFieldDecorator('order', {
                                    initialValue: this.props.initialData.order ? this.props.initialData.order : null,
                                    rules: [
                                        {
                                            required: true,
                                            message: 'اولویت اجباری است',
                                        },
                                        {
                                            ///only numbers from 1 to 250
                                            validator: async (_, order) => {
                                                if (order < 1 || order > 250 || isNaN(order)) {
                                                    return Promise.reject(new Error("اولویت باید عددی بین 1 تا 250 باشد"));
                                                }
                                            },
                                        }
                                    ],
                                })(
                                    <Input />
                                )}
                            </FormItem>
                        </Col>

                    </Row>

                    <FormItem>
                        <div className="btn-container">
                            <Button
                                type="primary"
                                htmlType="submit"
                                disabled={hasErrors(getFieldsError()) || this.props.submitted}
                            >
                                {this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                            </Button>
                        </div>
                    </FormItem>
                </Form>
            </div>
        )
    }
}
BreadCrumbsForm.defaultValue = {
    initialData: {}
}

export default Form.create()(BreadCrumbsForm);



// WEBPACK FOOTER //
// ./src/containers/BreadCrumbs/form.js